<div class="container bg-white py-7">
    <nav class="row-auto g-0 d-flex justify-content-between">
        <!-- Left Nav Wrapper-->
        <div>
            <app-link
                *ngIf="leftNavRouterLink"
                [appRouterLink]="isAddonView ? null : leftNavRouterLink.routerLink"
                [href]="isAddonView ? leftNavRouterLink.routerLink : null"
                class="d-flex justify-content-start text-primary fw-bold font-size-16"
                [target]="'_blank'"
            >
                <app-icon class="arrow-left font-size-10 ms-1" [type]="'Arrow-left'"></app-icon>
                <span> {{ leftNavRouterLink.name }}</span>
            </app-link>
        </div>

        <!-- Right Nav Wrapper -->
        <div>
            <app-link
                *ngIf="rightNavRouterLink"
                [appRouterLink]="isAddonView ? null : rightNavRouterLink.routerLink"
                [href]="isAddonView ? rightNavRouterLink.routerLink : null"
                class="d-flex justify-content-start text-primary fw-bold font-size-16 font-"
                [target]="'_blank'"
            >
                <span> {{ rightNavRouterLink.name }}</span>
                <app-icon class="arrow-left font-size-10 ms-1" [type]="'Arrow-right'"></app-icon>
            </app-link>
        </div>
    </nav>
</div>
